export const isAuthSelector = (state: any) =>
  state.AuthenticationReducer.isAuth;

export const permissionListSelector = (state: any) =>
  state.AuthenticationReducer.permissionList;

export const refreshSessionSelector = (state: any) =>
  state.AuthenticationReducer.refreshSession;
